<script>
    import {showThankUPopUp} from './store.js';
    let close;
    showThankUPopUp.subscribe((value) => {
        close = value;
    });
    export let headingText = 'Email Sent!';
    export let paraText = 'We have received your email and will get back to you shortly.';
</script>
<div class="desktop">
    {#if close}
        <div class="div_wrraper">
            <div class="main-div">
                <div><p class="heading">{headingText}</p></div>
                <div class="text-div">
                    <p class="text">
                        {paraText}
                    </p>
                </div>
                <div>
                    <button on:click={() => {
                        if (close === 1) {
                            close = 0;
                            showThankUPopUp.update((n) => 0);
                        }
                    }}
                        ><p
                            style="font-weight: 500 ; padding: 1vw; color: white; font-size: 1.190vw;"
                        >
                            Done
                        </p></button
                    >
                </div>
            </div>
        </div>
    {/if}
</div>

<div class="mobile">
    {#if close}
        <div class="div_wrraper-mobile">
            <div class="main-div-mobile">
                <div><p class="heading-mobile">{headingText}</p></div>
                <div class="mob-text">
                    <p class="p-mobile">
                        {paraText}
                    </p>
                </div>

                <div>
                    <button class="button-mobile" on:click={() => {
                        if (close === 1) {
                            close = 0;
                            showThankUPopUp.update((n) => 0);
                        }
                    }}
                        ><p
                            style="font-weight: 500; text-align: center;padding: 1.5vw; color: white; font-size: 2.314vw;"
                        >
                            Done
                        </p></button
                    >
                </div>
            </div>
        </div>
    {/if}
</div>

<style>
    .div_wrraper {
        width: 100%;
        height: 100%;
        position: fixed;
        background-color: #00183861;
        top: 0.001vw;
        z-index: 2147483645;
    }
    .main-div {
        position: absolute;
        width: 41.27vw;
        padding-bottom: 2vw;
        background: white;
        border-radius: 1.323vw;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .heading {
        text-transform: uppercase;
        text-align: center;
        margin-top: 2.057vw;
        color: rgba(0, 32, 75, 1);
        font-size: 1.323vw;
        font-weight: 600;
        text-transform: uppercase;
    }
    .text-div{
        width: 31.334vw;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: -0.8vw;
        margin-top: 1vw;
    }
    .text {
        margin-left: 0vw;
        text-align: center;
        color: rgba(0, 32, 75, 1);
        font-size: 0.926vw;
        font-weight: 300;
        margin-bottom: 0;
    }
    button {
        font-size: 1.058vw;
        margin-top: 2.249vw;
        margin-left: 16.667vw;
        background-color: rgba(60, 116, 192, 1);
        height: 3.638vw;
        width: 9.193vw;
        border-radius: 1.984vw;
        border: none;
    }
    .div_wrraper-mobile {
        width: 100%;
        height: 100%;
        position: fixed;
        background-color: #00183861;
        top: 0vw;
        z-index: 2147483645;
    }
    .main-div-mobile {
        position: absolute;
        width: 86.389vw;
        padding-bottom: 5vw;
        background: white;
        border-radius: 1.323vw;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }

    .heading-mobile {
        text-align: center;
        margin-top: 4vw;
        color: rgba(0, 32, 75, 1);
        font-size: 3.056vw;
        font-weight: 600;
    }
    .mob-text{
        width: 66vw;
        margin-left: auto;
        margin-right: auto;
    }
    .p-mobile {
        font-size: 1.944vw;
        margin-top: 6.367vw;
        color: rgba(0, 32, 75, 1);
        font-weight: 300;
        text-align: center;
    }
    .button-mobile {
        margin-left: 34.722vw;
        margin-top: -0.372vw;
        background-color: rgba(60, 116, 192, 1);
        height: 6.8vw;
        width: 17.217vw;
        border-radius: 4.342vw;
        border: none;
    }
    .desktop {
        display: block;
    }
    .mobile {
        display: none;
    }
    @media screen and (max-width: 1024px) {
        .desktop {
            display: none;
        }
        .mobile {
            display: block;
        }
        
    }
  
</style>
